import { CONFIG } from '~/_shared/constants/config';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import type { AppState } from '~/store/app.store';
import { selectAllV4Maps } from '~/store/mapMigration/selectors/mapsForMigration.selector';
import { userCurrentClientSelector } from '~/store/userData/userData.selectors';

const areV4MapsLoadedSelector = (state: AppState) => state.mapMigration.areV4MapsLoaded;
export const useAreV4MapsLoadedSelector = () => useSelector(areV4MapsLoadedSelector);

const canUserInitiateMigrationSelector = createStateSelector([
  userCurrentClientSelector,
  selectAllV4Maps,
  areV4MapsLoadedSelector,
], (currentClient, mapsToMigrate, areV4MapsLoaded) => {
  const migrationFeatureEnabled = CONFIG.ENABLE_MIGRATION;

  const migrationInProgress = currentClient?.migrationDone === false;
  const hasMapsToMigrate = mapsToMigrate.length !== 0;
  const userHasAlreadyMigratedSomeMaps = !migrationInProgress || mapsToMigrate.some(
    map => map.migrationStatus !== 'NOT_STARTED'
  );

  return {
    isLoading: migrationInProgress ? !areV4MapsLoaded : false,
    canUserInitiateMigration: migrationFeatureEnabled
      && migrationInProgress
      && hasMapsToMigrate,
    userHasAlreadyMigratedSomeMaps,
  };
});

export const useCanUserInitiateMigrationSelector = () => useSelector(canUserInitiateMigrationSelector);
